<template>
  <div
    :style="scaleStyle"
    ref="previewMain"
    :class="{ 'is-sample': isSample, 'is-preview': !isSample }"
  >
    <div class="doc-paper preview rirekisho" :id="idPrefix + 'preview-page-01'">
      <div class="flex">
        <div class="rirekisho-box1">
          <div class="rirekisho-header">
            <div class="title">履歴書</div>
            <div
              class="date"
              @click="goCardTo('create-date')"
              :class="highLightClass('create-date')"
            >
              <span v-html="formatedCreateDate"></span> 現在
            </div>
          </div>
          <div
            class="rirekisho-profile"
            :data-highlight="highlightMessage"
            @click="goCardTo('profile')"
            :class="highLightClass('profile')"
          >
            <div class="ruby flex">
              <div class="label">ふりがな</div>
              <div class="input" :style="formatData.selFontStyle">
                {{ basicData.lastNameFurigana }}&emsp;{{
                  basicData.firstNameFurigana
                }}
              </div>
            </div>
            <div class="name flex">
              <div class="label">名前</div>
              <div class="input" :style="formatData.selFontStyle">
                {{ basicData.lastName }}&emsp;{{ basicData.firstName }}
              </div>
            </div>
            <div class="etc flex">
              <div class="birthday" :style="formatData.selFontStyle">
                <span class="year">{{ basicData.birthYear }}</span
                >年 <span class="month">{{ basicData.birthMonth }}</span
                >月 <span class="day">{{ basicData.birthDay }}</span
                >日生（満 <span class="age">{{ age }}</span> 歳）
              </div>

              <div class="gender">
                <span
                  class="male"
                  v-if="!isGenderDisplay"
                  v-bind:class="{ 'preview-is-checked': isMale }"
                  >男</span
                ><span v-if="!isGenderDisplay">・</span>
                <span
                  class="female"
                  v-if="!isGenderDisplay"
                  v-bind:class="{ 'preview-is-checked': isFemale }"
                  >女</span
                >
              </div>
            </div>
          </div>
        </div>
        <div
          class="rirekisho-photo"
          :data-highlight="highlightMessage"
          @click="goCardTo('id-photo')"
          :class="highLightClass('id-photo')"
        >
          <div v-if="basicData.idPhotoSrc">
            <img :src="basicData.idPhotoSrc" alt="証明写真" />
          </div>
          <div v-else>
            <div class="rirekisho-photo-inner">
              <p>
                証明写真 <br />縦 36mm&#12316;40mm <br />横 24mm&#12316;30mm
                <br />本人単身胸から上 <br />裏面のりづけ
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="rirekisho-box2">
        <div class="contact-information contact-main flex">
          <div
            class="contact-information-address"
            :data-highlight="highlightMessage"
            @click="goCardTo('address')"
            :class="highLightClass('address')"
          >
            <div class="ruby flex">
              <div class="label">ふりがな</div>
              <div
                class="input"
                ref="addressFurigana"
                :class="classObject.addressFurigana"
                :style="formatData.selFontStyle"
              >
                {{ basicData.addressFurigana }}
              </div>
            </div>
            <div class="address flex">
              <div class="label">現住所</div>
              <div class="input">
                <div class="postal-code" :style="formatData.selFontStyle">
                  &#12306;{{
                    formLib.separatedPostNumber(basicData.postNumber)
                  }}
                </div>
                <pre :style="formatData.selFontStyle"
                  >{{ basicData.address1 }}
{{ basicData.address2 }}</pre>
              </div>
            </div>
          </div>
          <div
            class="contact-information-etc"
            :data-highlight="highlightMessage"
            @click="goCardTo('contacts')"
            :class="highLightClass('contacts')"
          >
            <div class="tel flex">
              <div class="label">電話</div>
              <div class="input" :style="formatData.selFontStyle">
                {{ tel }}
              </div>
            </div>
            <div class="email flex">
              <div class="label">Email</div>
              <div class="input" :style="formatData.selFontStyle">
                {{ basicData.email }}
              </div>
            </div>
          </div>
        </div>
        <div class="contact-information contact-sub flex">
          <div
            class="contact-information-address"
            @click="goCardTo('address')"
            :class="highLightClass('address')"
          >
            <div class="ruby flex">
              <div class="label">ふりがな</div>
              <div
                class="input"
                :class="{
                  'font-size-sm':
                    formLib.charCount(basicData.contactAddressFurigana) > 59
                }"
                :style="formatData.selFontStyle"
              >
                {{ basicData.contactAddressFurigana }}
              </div>
            </div>
            <div class="address flex">
              <div class="label">連絡先</div>
              <div class="input">
                <div class="postal-code" :style="formatData.selFontStyle">
                  &#12306;{{
                    formLib.separatedPostNumber(basicData.contactPostNumber)
                  }}
                </div>
                <div class="comment">
                  (現住所以外に連絡を希望する場合のみ入力)
                </div>
                <pre :style="formatData.selFontStyle"
                  >{{ basicData.contactAddress1 }}
{{ basicData.contactAddress2 }}</pre>
                <div
                  class="care-of"
                  v-if="basicData.contactCareOf"
                  :style="formatData.selFontStyle"
                >
                  {{ basicData.contactCareOf }} 方
                </div>
              </div>
            </div>
          </div>
          <div
            class="contact-information-etc"
            @click="goCardTo('contacts')"
            :class="highLightClass('contacts')"
          >
            <div class="tel flex">
              <div class="label">電話</div>
              <div class="input" :style="formatData.selFontStyle">
                {{ contactTel }}
              </div>
            </div>
            <div class="email flex">
              <div class="label">Email</div>
              <div class="input" :style="formatData.selFontStyle">
                {{ basicData.contactEmail }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="rirekisho-table rirekisho-history-1"
        :data-highlight="highlightMessage"
        @click="goCardTo('edu-history')"
        :class="highLightClass(['edu-history', 'job-history'])"
      >
        <table :class="{ error: errorMessages.eduJobHistory }">
          <thead>
            <tr>
              <th>年</th>
              <td>月</td>
              <td>学歴・職歴</td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in eduJobHistoryTable.slice(0, 16)"
              v-bind:class="item.classObject"
              :key="index"
            >
              <th :style="formatData.selFontStyle">{{ item.year }}</th>
              <td :style="formatData.selFontStyle">{{ item.month }}</td>
              <td
                :class="{
                  'font-size-sm': formLib.charCount(item.description) > 68
                }"
                :style="formatData.selFontStyle"
              >
                {{ item.description }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="doc-paper preview rirekisho" :id="idPrefix + 'preview-page-02'">
      <div
        class="rirekisho-table rirekisho-skill"
        :data-highlight="highlightMessage"
        @click="goCardTo('license-history')"
        :class="highLightClass('license-history')"
      >
        <table :class="{ error: errorMessages.licenseHistory }">
          <thead>
            <tr>
              <th>年</th>
              <td>月</td>
              <td>免許・資格</td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in licenseHistoryTable.slice(0, 5)"
              v-bind:class="item.classObject"
              :key="index"
            >
              <th :style="formatData.selFontStyle">{{ item.year }}</th>
              <td :style="formatData.selFontStyle">{{ item.month }}</td>
              <td
                :class="{
                  'font-size-sm': formLib.charCount(item.description) > 68
                }"
                :style="formatData.selFontStyle"
              >
                {{ item.description }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="rirekisho-pr" style="height: 170px">
        <div
          class="rirekisho-pr-reason"
          v-if="formatId != 'rirekisho_job_change'"
          :data-highlight="highlightMessage"
          @click="goCardTo('reason')"
          :class="highLightClass('reason')"
          style="width: 100%"
        >
          <div class="label">志望動機</div>
          <div class="input">
            <pre
              ref="reason"
              :class="classObject.reason"
              :style="formatData.selFontStyle"
              >{{ formatData.reason }}</pre>
          </div>
        </div>
      </div>
      <div class="rirekisho-pr" style="height: 170px">
        <div
          class="rirekisho-pr-reason"
          v-if="formatId != 'rirekisho_job_change'"
          :data-highlight="highlightMessage"
          @click="goCardTo('reasonNew')"
          :class="highLightClass('reasonNew')"
          style="width: 100%"
        >
          <div class="label">自己PR</div>
          <div class="input">
            <pre
              ref="reasonNew"
              :class="classObject.reasonNew"
              :style="formatData.selFontStyle"
              >{{ formatData.reasonNew }}</pre>
          </div>
        </div>
      </div>
      <div class="rirekisho-pr" style="height: 170px">
        <div
          class="rirekisho-pr-reason"
          v-if="formatId != 'rirekisho_job_change'"
          :data-highlight="highlightMessage"
          @click="goCardTo('hobby')"
          :class="highLightClass('hobby')"
          style="width: 100%"
        >
          <div class="label">趣味・特技など</div>
          <div class="input">
            <pre
              ref="hobby"
              :class="classObject.hobby"
              :style="formatData.selFontStyle"
              >{{ formatData.hobby }}</pre>
          </div>
        </div>
      </div>
      <div
        class="rirekisho-hope"
        :data-highlight="highlightMessage"
        @click="goCardTo('requests')"
        :class="highLightClass('requests')"
      >
        <div class="label">
          本人希望欄（特に給料・職種・勤務時間・勤務地・その他について希望があれば記入）
        </div>
        <div class="input">
          <pre
            ref="request"
            :class="classObject.request"
            :style="formatData.selFontStyle"
            >{{ formatData.request }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useRirekishoPreview } from '@/composables/format-edit/useRirekishoPreview'

type FormatPreviewSfcProps = {
  formatData: Record<string, any>
  basicData: Record<string, any>
  previewScale?: number
  currentCardId?: string | string[]
  idPrefix?: string
  isSample?: boolean
  formatId?: string
}

const props = withDefaults(defineProps<FormatPreviewSfcProps>(), {
  previewScale: 1,
  currentCardId: '',
  idPrefix: '',
  isSample: false
})

const {
  reason,
  reasonNew,
  request,
  addressFurigana,
  hobby,
  checkValid,
  formLib,
  scaleStyle,
  highlightMessage,
  goCardTo,
  highLightClass,
  classObject,
  errorMessages,
  tel,
  contactTel,
  age,
  formatedCreateDate,
  isMale,
  isFemale,
  isGenderDisplay,
  eduJobHistoryTable,
  licenseHistoryTable,
  optionItems
} = useRirekishoPreview(props, {
  maxEduJobRows: 22,
  maxLicenseRows: 6,
  textareaMaxHeights: { reason: 175, reasonNew: 175, hobby: 175, request: 180 },
  overflowFields: [
    'reason',
    'reasonNew',
    'hobby',
    'request',
    'addressFurigana'
  ],
  revalidateOnFormatDataChange: true
})

defineExpose({
  checkValid,
  errorMessages,
  optionItems,
  reason,
  reasonNew,
  request,
  addressFurigana,
  hobby
})
</script>
